import * as CONST from "./Constants";

export const FileNameFromUrl = (url) => {
  let matched = url.match(/\/([^\/?#]+)[^\/]*$/);
  if (matched.length > 1) {
    return matched[1];
  }
  return "no file found";
};

export const daysInMonth = (year, month) => {
  return (new Date(year, month, 0).getDate()) + 1;
};

export const getDate = (month, day, year) => {
  return new Date(month + '/' + day + '/' + year);
};

export const ConvertToPacificTime = (str) => {
  try {
    return new Date(str).toLocaleTimeString("en-US", {
      timeZone: "PST",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (error) {
    return new Date(str).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
}
export const ConvertTime = (str) => {
  str = String(str).toLowerCase().replace(/\s/g, "");
  let am = str.indexOf("am") >= 0;
  let pm = str.indexOf("pm") >= 0;
  str = str.replace("am", "").replace("pm", "");
  if (str.indexOf(":") < 0) str = str + ":00";
  if (am) str += " am";
  if (pm) str += " pm";
  let d = new Date("1/1/2011 " + str);
  let doubleDigits = function (n) {
    return parseInt(n) < 10 ? "0" + n : String(n);
  };
  return doubleDigits(d.getHours()) + ":" + doubleDigits(d.getMinutes());
};

export const AppointmentLabelMapper = (status) => {
  let label;
  status == "appointment_request_created" ||
  status == "pcp_appointment_request_received" ||
  status == "pcp_contacted_patient"
    ? (label = "Appointment Request")
    : status == "appointment_confirmed"
    ? (label = "Appointment Scheduled")
    : status == "visit_status_check"
    ? (label = "Appointment Status Check")
    : status == "appointment_completed"
    ? (label = "Appointment Completed")
    : status == ("appointment_not_completed" || "pcp_denied_appointment_request")
    ? (label = "Appointment Not Completed")
    : (label = "Appointment ");
  return label;
};

export const CprListLabelMapper = (taskStatus, cpr) => {
  let label;
  cpr.sub_status && cpr.sub_status == CONST.CPR.PATIENT_REPORTED_COMPLETED
    ? (label = "Care Plan Requirement (CPR) Patient Reported Completed")
    : cpr.sub_status && cpr.sub_status == CONST.CPR.RESULTS_OBTAINED
    ? (label = "Care Plan Requirement (CPR) Completed")
    : (cpr.sub_status && cpr.sub_status == CONST.CPR.RESULTS_PENDING) ||
      (cpr.sub_status && cpr.sub_status == CONST.CPR.VERIFIED_BY_CLAIMS)
    ? (label = "Care Plan Requirement (CPR) Status Check")
    : cpr.status == "closed" &&
      taskStatus == "closed" &&
      cpr.sub_status &&
      cpr.sub_status.includes("closed")
    ? (label = "Care Plan Requirement (CPR) Closed")
    : cpr.extended == true
    ? (label = "Care Plan Requirement (CPR) Extended")
    : taskStatus == "closed" &&
      (cpr.sub_status == CONST.CPR.CANCELED ||
        cpr.sub_status == CONST.CPR.NO_SHOW ||
        cpr.sub_status == CONST.CPR.REQUIRED)
    ? (label = "Care Plan Requirement (CPR) Required")
    : (label = "Care Plan Requirement (CPR) Patient Response");
  return label;
};

export const scrollToView = (elem, timeOnScroll) => {
  const anchor = document.querySelector(elem);
  setTimeout(() => {
    if (anchor) {
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, timeOnScroll);
}

export const AppointmentAlertMapper = (task) => {
  const taskOpen = task.status == "open" || task.status == "pending";
  const subStatus = task.cpr?.sub_status;
  let verifiedInClaims = task.cpr?.verified_in_claims;

  // Closed as Appointment Completed: nothing left for the agent to do.
  if (!taskOpen && task.appointment_request_status == "appointment_completed") return "";

  if (taskOpen && subStatus == CONST.CPR.RESULTS_OBTAINED) return "Data entry needed";
  if (subStatus == CONST.CPR.RESULTS_PENDING || subStatus == CONST.CPR.VERIFIED_BY_CLAIMS) return "Results needed";
  return "";
};

export const CprLabelMapper = (taskStatus, cpr) => {
  let label;
  cpr.sub_status && cpr.sub_status == CONST.CPR.PATIENT_REPORTED_COMPLETED
    ? (label = {
        label: "Care Plan Requirement (CPR) Patient Reported Completed",
        alert: "",
      })
    : (taskStatus == "open" || taskStatus == "pending") &&
      cpr.sub_status &&
      cpr.sub_status == CONST.CPR.RESULTS_OBTAINED
    ? (label = {
        label: "Care Plan Requirement (CPR) Completed",
        alert: "Data entry needed",
      })
    : taskStatus == "closed" && cpr.sub_status && cpr.sub_status == CONST.CPR.RESULTS_OBTAINED
    ? (label = {
        label: "Care Plan Requirement (CPR) Completed",
        alert: "",
      })
    : (cpr.sub_status && cpr.sub_status == CONST.CPR.RESULTS_PENDING) ||
      (cpr.sub_status && cpr.sub_status == CONST.CPR.VERIFIED_BY_CLAIMS)
    ? (label = {
        label: "Care Plan Requirement (CPR) Results Needed",
        alert: "Results needed",
      })
    : cpr.status == "closed" &&
      taskStatus == "closed" &&
      cpr.sub_status &&
      cpr.sub_status.includes("closed")
    ? (label = {
        label: "Care Plan Requirement (CPR) Closed",
        alert: "",
      })
    : taskStatus == "closed" && cpr.status == "confirmation" && !cpr.sub_status
    ? (label = {
        label: "Care Plan Requirement (CPR) Extended",
      })
    : taskStatus == "closed" &&
      (cpr.sub_status == CONST.CPR.CANCELED ||
        cpr.sub_status == CONST.CPR.NO_SHOW ||
        cpr.sub_status == CONST.CPR.REQUIRED)
    ? (label = {
        label: "Care Plan Requirement (CPR) Required",
      })
    : (label = {
        label: "Care Plan Requirement (CPR) Patient Response",
      });
  return label;
};

export const getVisitTypeId = (name, visitTypes) => {
  const visitType = visitTypes.find((i) => (i.name == name ? i : ""));
  if(visitType) {
    return visitType.id;
  } else {
    return null;
  }
};

export const getSubStatusListId = (status, subStatuses) => {
  const subStatus = subStatuses.find((i) => (i.name == status ? i : ""));
  if(subStatus) {
    return subStatus.id;
  } else {
    return null;
  }
};
